import { motion } from "motion/react";
import { Infinity, TrendingUp, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

const WHY_US_IMAGE_URL = "https://lh3.googleusercontent.com/aida-public/AB6AXuCU71eql-I5wLRw5QT2HwpXAHkds944lhqiKZvQxa68ibUzstRnaK4aCYUzlWJlgu3OAJsnGAM5fAM6sgZgVWA3yNsJCpIeIh4KPl2jXATHrEWIrrcbMg5lyuw9AUPq3pz_algrbciPNTMlyQaz5NyeYTcp8bpqNYiGN2s0vT9a3F5yi79p9Vp2fjxtAQeYkh9KAsKhpD-KpIWVvCNInXjU3_xoK4cakRmWMcwFyAHoyC8NnAINHG8ZTM7S-vmRXi0PDtH2OrJiQig";

const WHY_US_ITEMS = [
  { icon: <Infinity />, key: "end_to_end" },
  { icon: <TrendingUp />, key: "scalability" },
  { icon: <ShieldCheck />, key: "security" },
] as const;

export default function WhyUs() {
  const { t } = useTranslation();

  return (
    <section id="insights" className="py-24 bg-surface-container-low border-y border-outline-variant scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-on-surface mb-8">{t('why_us.title')}</h2>
          <div className="space-y-4">
            {WHY_US_ITEMS.map((item, idx) => (
              <div key={idx} className="flex gap-4 p-6 bg-white rounded-xl border border-outline-variant hover:border-primary-container transition-all shadow-sm">
                <div className="shrink-0 w-10 h-10 bg-surface-container rounded-full flex items-center justify-center text-primary-container">
                  {item.icon}
                </div>
                <div>
                  <h4 className="font-bold mb-1">{t(`why_us.items.${idx}.title`)}</h4>
                  <p className="text-on-surface-variant text-sm leading-relaxed">{t(`why_us.items.${idx}.description`)}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="relative"
        >
          <img 
            src={WHY_US_IMAGE_URL} 
            className="rounded-2xl shadow-2xl w-full" 
            alt="Our Team" 
            referrerPolicy="no-referrer"
          />
          <div className="absolute -bottom-6 -right-6 bg-primary-container text-white p-8 rounded-xl shadow-xl">
            <p className="text-4xl font-bold">{t('why_us.experience')}</p>
            <p className="text-[10px] font-bold uppercase tracking-widest opacity-80">{t('why_us.experience_label')}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}